import { useCallback, useMemo } from 'react';
import * as THREE from 'three';
import ceramicTileWhiteColor from '../../assets/textures/ceramic-tile-white/color.jpg';
import ceramicTileWhiteNormal from '../../assets/textures/ceramic-tile-white/normal.jpg';
import ceramicTileWhiteRoughness from '../../assets/textures/ceramic-tile-white/roughness.jpg';
import ceramicTileWhiteAo from '../../assets/textures/ceramic-tile-white/ao.jpg';
import ceramicTileWhiteTintMask from '../../assets/textures/ceramic-tile-white/tintmask.jpg';
import brickRedColor from '../../assets/textures/brick-red/color.jpg';
import brickRedNormal from '../../assets/textures/brick-red/normal.jpg';
import brickRedRoughness from '../../assets/textures/brick-red/roughness.jpg';
import brickRedAo from '../../assets/textures/brick-red/ao.jpg';
import brickRedTintMask from '../../assets/textures/brick-red/tintmask.jpg';
import concreteGrayColor from '../../assets/textures/concrete-gray/color.jpg';
import concreteGrayNormal from '../../assets/textures/concrete-gray/normal.jpg';
import concreteGrayRoughness from '../../assets/textures/concrete-gray/roughness.jpg';
import parquetOakColor from '../../assets/textures/parquet-oak/color.jpg';
import parquetOakNormal from '../../assets/textures/parquet-oak/normal.jpg';
import parquetOakRoughness from '../../assets/textures/parquet-oak/roughness.jpg';
import parquetOakAo from '../../assets/textures/parquet-oak/ao.jpg';
import marbleVeinedColor from '../../assets/textures/marble-veined/color.jpg';
import marbleVeinedNormal from '../../assets/textures/marble-veined/normal.jpg';
import marbleVeinedRoughness from '../../assets/textures/marble-veined/roughness.jpg';
import graniteSpeckledColor from '../../assets/textures/granite-speckled/color.jpg';
import graniteSpeckledNormal from '../../assets/textures/granite-speckled/normal.jpg';
import graniteSpeckledRoughness from '../../assets/textures/granite-speckled/roughness.jpg';
import metalBrushedColor from '../../assets/textures/metal-brushed/color.jpg';
import metalBrushedNormal from '../../assets/textures/metal-brushed/normal.jpg';
import metalBrushedRoughness from '../../assets/textures/metal-brushed/roughness.jpg';
import metalBrushedMetalness from '../../assets/textures/metal-brushed/metalness.jpg';
import woodPineColor from '../../assets/textures/wood-pine/color.jpg';
import woodPineNormal from '../../assets/textures/wood-pine/normal.jpg';
import woodPineRoughness from '../../assets/textures/wood-pine/roughness.jpg';
import travertineColor from '../../assets/textures/travertine/color.jpg';
import travertineNormal from '../../assets/textures/travertine/normal.jpg';
import travertineRoughness from '../../assets/textures/travertine/roughness.jpg';
import travertineAo from '../../assets/textures/travertine/ao.jpg';
import carpetColor from '../../assets/textures/carpet/color.jpg';
import carpetNormal from '../../assets/textures/carpet/normal.jpg';
import carpetRoughness from '../../assets/textures/carpet/roughness.jpg';
import carpetAo from '../../assets/textures/carpet/ao.jpg';
import woodDarkColor from '../../assets/textures/wood-dark/color.jpg';
import woodDarkNormal from '../../assets/textures/wood-dark/normal.jpg';
import woodDarkRoughness from '../../assets/textures/wood-dark/roughness.jpg';
import laminateLightColor from '../../assets/textures/laminate-light/color.jpg';
import laminateLightNormal from '../../assets/textures/laminate-light/normal.jpg';
import laminateLightRoughness from '../../assets/textures/laminate-light/roughness.jpg';
import laminateDarkColor from '../../assets/textures/laminate-dark/color.jpg';
import laminateDarkNormal from '../../assets/textures/laminate-dark/normal.jpg';
import laminateDarkRoughness from '../../assets/textures/laminate-dark/roughness.jpg';
import plasterWhiteColor from '../../assets/textures/plaster-white/color.jpg';
import plasterWhiteNormal from '../../assets/textures/plaster-white/normal.jpg';
import plasterWhiteRoughness from '../../assets/textures/plaster-white/roughness.jpg';
import paintedPlasterColor from '../../assets/textures/painted-plaster/color.jpg';
import paintedPlasterNormal from '../../assets/textures/painted-plaster/normal.jpg';
import paintedPlasterRoughness from '../../assets/textures/painted-plaster/roughness.jpg';
import wallpaperColor from '../../assets/textures/wallpaper/color.jpg';
import wallpaperNormal from '../../assets/textures/wallpaper/normal.jpg';
import wallpaperRoughness from '../../assets/textures/wallpaper/roughness.jpg';

// این فایل، برخلافِ materialTextures.js (که همه‌چیز را با canvas/کد می‌سازد)، بافت‌های واقعیِ PBR را
// از عکسِ واقعی بارگذاری می‌کند — همان فایل‌هایی که کاربر از ambientcg.com دانلود و به پروژه اضافه
// کرد (زیرِ src/assets/textures/...). هر «ست» شاملِ ۴ نقشه است:
//   • color      — رنگ/آلبیدوی واقعیِ سطح (عکسِ خامِ متریال)
//   • normal     — نقشه‌ی برجستگی (باعثِ سایه‌روشنِ واقعیِ درزها/جزئیاتِ ریز می‌شود، بدونِ هندسه‌ی اضافه)
//   • roughness  — زبریِ واقعیِ سطح در هر پیکسل (کاشیِ صیقلی = تیره/کم‌زبری، درزِ مات = روشن‌تر)
//   • ao         — سایه‌ی طبیعیِ خودِ سطح (گوشه‌ها/درزها کمی تیره‌تر، دقیقاً مثلِ نور واقعی)
// نکته‌ی مهم: رنگِ اصلی‌ای که کاربر از پنلِ تنظیمات انتخاب می‌کند، مستقیماً روی خودِ عکس «ضرب» می‌شود
// (چون در three.js، material.color همیشه در material.map ضرب می‌شود) — یعنی انتخاب‌گرِ رنگِ خودِ اپ
// همچنان کار می‌کند، بدونِ این‌که واقعی‌بودنِ عکس (بافت/جزئیات/نور) از بین برود.
export const PBR_SETS = {
  ceramicTileWhite: {
    color: ceramicTileWhiteColor,
    normal: ceramicTileWhiteNormal,
    roughness: ceramicTileWhiteRoughness,
    ao: ceramicTileWhiteAo,
    // ماسکِ رنگ: سفید = خودِ کاشی (رنگ می‌گیرد)، سیاه = بندکشی (رنگِ طبیعی‌اش می‌ماند) — نگاه کنید به useTintProps
    tintMask: ceramicTileWhiteTintMask,
    // این عکس یک شبکه‌ی ۸×۸ از کاشی‌های سفیدِ براق را نشان می‌دهد. baseSizeCm یعنی «کلِ عکس، اگر
    // repeat=1 باشد، چقدر جا (سانتی‌متر) روی دیوار/کف می‌گیرد» — از همین عدد، اندازه‌ی هر کاشیِ تکی
    // (baseSizeCm / tilesPerImage) برای محاسبه‌ی تکرارِ متناسب با اندازه‌ی دلخواهِ کاربر استفاده می‌شود
    tilesPerImage: 8,
    baseSizeCm: 240,
  },
  brickRed: {
    color: brickRedColor,
    normal: brickRedNormal,
    roughness: brickRedRoughness,
    ao: brickRedAo,
    // ماسکِ رنگ: سفید = خودِ آجر، سیاه = ملات (رنگِ طبیعی‌اش می‌ماند)
    tintMask: brickRedTintMask,
    // این عکس یک آجرچینِ استانداردِ نارنجی/قرمز را نشان می‌دهد — تقریباً ۶ آجر در عرضِ عکس، هر آجر
    // با احتسابِ بندکشی حدودِ ۲۵ سانتی‌متر (همان فرضِ آجرِ کدنویسی‌شده‌ی createBrickTexture)
    tilesPerImage: 6,
    baseSizeCm: 150,
  },
  concreteGray: {
    color: concreteGrayColor,
    normal: concreteGrayNormal,
    roughness: concreteGrayRoughness,
    // این ست (برخلافِ کاشی/آجر) نقشه‌ی ao ندارد — خودِ ست‌هایی که از ambientcg می‌آیند همیشه ۴ نقشه
    // ندارند؛ loadPbrMaps/loadMap این حالت را خودشان مدیریت می‌کنند (url نبود = aoMap نهایی هم null)
    //
    // بتن/گچِ یک‌دست است، نه یک الگوی تکرارشوندهٔ مشخص (کاشی/آجر) — پس «یک واحدِ تکرار» یعنی کلِ خودِ
    // عکس، برای همین tilesPerImage همیشه ۱ است؛ baseSizeCm یعنی «کلِ عکس، اگر repeat=1 باشد، چقدر
    // جا (سانتی‌متر) روی دیوار/کف می‌گیرد»
    tilesPerImage: 1,
    baseSizeCm: 200,
  },
  parquetOak: {
    color: parquetOakColor,
    normal: parquetOakNormal,
    roughness: parquetOakRoughness,
    ao: parquetOakAo,
    // این عکس یک پارکتِ چوبیِ هرینگ‌بونِ (استخوان‌ماهی‌ای) واقعی را نشان می‌دهد — تقریباً ۷ ستونِ
    // الگو در عرضِ عکس؛ فقط برای کف کاربرد دارد (این پروژه پوششِ چوبی برای دیوار ندارد)
    tilesPerImage: 7,
    baseSizeCm: 140,
  },
  marbleVeined: {
    color: marbleVeinedColor,
    normal: marbleVeinedNormal,
    roughness: marbleVeinedRoughness,
    // این ست هم مثلِ concreteGray نقشه‌ی ao ندارد. سنگِ اسلب (سنگِ رگه‌دار) هم مثلِ بتن یک‌دست است —
    // یک رگه‌ی پیوسته روی کلِ عکس، نه یک الگوی تکرارشوندهٔ کوچک — برای همین tilesPerImage اینجا هم ۱
    // است؛ baseSizeCm بزرگ‌تر انتخاب شده (نسبت به بتن) تا رگه‌های مرمر پخش‌تر/کم‌تکرارتر دیده شوند،
    // دقیقاً حسِ یک اسلبِ بزرگِ واقعی نه کاشیِ کوچکِ تکرارشونده
    tilesPerImage: 1,
    baseSizeCm: 200,
  },
  graniteSpeckled: {
    color: graniteSpeckledColor,
    normal: graniteSpeckledNormal,
    roughness: graniteSpeckledRoughness,
    // این ست هم AO ندارد. برخلافِ مرمرِ رگه‌دار (رگه‌های بلند/پیوسته)، گرانیت لکه‌های ریزِ پراکنده
    // دارد — برای همین baseSizeCm کوچک‌تر انتخاب شده تا لکه‌ها در اندازه‌ی طبیعیِ خودشان دیده شوند،
    // نه کِش‌آمده روی یک سطحِ بزرگ
    tilesPerImage: 1,
    baseSizeCm: 160,
  },
  metalBrushed: {
    color: metalBrushedColor,
    normal: metalBrushedNormal,
    roughness: metalBrushedRoughness,
    // اولین ستی که نقشه‌ی metalness دارد — فلزها برخلافِ کاشی/چوب/سنگ، «فلزی‌بودن» را هم به‌صورتِ
    // per-pixel نیاز دارند (metalnessMap)، نه فقط رنگ/برجستگی/زبری. این ست هم مثلِ بقیه‌ی ست‌های
    // «یک‌دست» AO ندارد.
    //
    // برخلافِ کف/دیوار (سطوحِ بزرگ)، این جنس روی نوارهای نازکِ قابِ پنجره/در استفاده می‌شود — برای
    // همین baseSizeCm خیلی کوچک‌تر انتخاب شده (اگر عددِ بزرگی مثلِ ۲۰۰ می‌بود، کلِ عکس روی یک نوارِ
    // ۵-۱۰ سانتی‌متری کِش می‌آمد و بافتِ فلز اصلاً دیده نمی‌شد)
    tilesPerImage: 1,
    baseSizeCm: 40,
    metalness: metalBrushedMetalness,
  },
  woodPine: {
    color: woodPineColor,
    normal: woodPineNormal,
    roughness: woodPineRoughness,
    // چوبِ روشنِ کاج (Wood092 از ambientcg) برای در و قابِ پنجره — AO و metalness ندارد (چوب فلز نیست،
    // پس metalness نهایی صفر می‌ماند). رگه‌های این عکس «عمودی»اند (در راستای محورِ V)، برای همین
    // grainAlongV=true: روی نوارهای افقی (نبشیِ بالا/پایینِ قاب) عکس ۹۰ درجه می‌چرخد تا رگه همیشه در
    // امتدادِ طولِ خودِ تخته باشد — دقیقاً مثلِ نجاریِ واقعی، نه رگه‌ی عرضی روی یک نوارِ باریک
    tilesPerImage: 1,
    baseSizeCm: 100,
    grainAlongV: true,
  },
  travertine: {
    color: travertineColor,
    normal: travertineNormal,
    roughness: travertineRoughness,
    ao: travertineAo,
    // تراورتنِ کرم با رگه‌های افقیِ پیوسته (Travertine009 از ambientcg) — سنگِ رایجِ نما/کف/حمام در
    // ایران. مثلِ مرمر یک اسلبِ یک‌دست است، نه الگوی کاشی‌کاری‌شده، پس tilesPerImage=1 و baseSizeCm
    // هم‌اندازه‌ی مرمر تا رگه‌ها پخش و طبیعی دیده شوند
    tilesPerImage: 1,
    baseSizeCm: 200,
  },
  carpet: {
    color: carpetColor,
    normal: carpetNormal,
    roughness: carpetRoughness,
    ao: carpetAo,
    // موکتِ پُرزدار (Carpet012 از ambientcg). عکسِ اصلی سُرمه‌ایِ تیره بود و چون رنگِ کاربر روی عکس
    // «ضرب» می‌شود، هیچ رنگِ روشنی (کرم/بژ) رویش دیده نمی‌شد — برای همین color.jpg این‌جا نسخه‌ی
    // خاکستریِ روشن و خنثیِ همان عکس است (فقط جزئیاتِ پُرزها، بدونِ رنگ) تا رنگِ موکت کاملاً از
    // انتخاب‌گرِ رنگِ اپ بیاید. normal.jpg هم از نقشه‌ی ارتفاعِ (Displacement) همین ست ساخته شده.
    // یک سطحِ یک‌دست است، پس tilesPerImage=1
    tilesPerImage: 1,
    baseSizeCm: 60,
  },
  woodDark: {
    color: woodDarkColor,
    normal: woodDarkNormal,
    roughness: woodDarkRoughness,
    // چوبِ تیره‌ی اسپرسویی/گردویی (Wood051 از ambientcg) برای در/پنجره/دیوار. برخلافِ کاج، رگه‌های این
    // عکس «افقی»اند (در راستای U)، پس grainAlongU=true: روی سطوحِ عمودی (لنگه‌ی در، نبشیِ کناریِ قاب)
    // عکس ۹۰ درجه می‌چرخد تا رگه همیشه در امتدادِ طولِ تخته باشد — نگاه کنید به getPbrLayout
    tilesPerImage: 1,
    baseSizeCm: 100,
    grainAlongU: true,
  },
  laminateLight: {
    color: laminateLightColor,
    normal: laminateLightNormal,
    roughness: laminateLightRoughness,
    // لمینت/تخته‌ی صافِ روشن (WoodFloor062) — تخته‌های باریک و بلند در ردیف‌های افقی، حدودِ ۳۲ ردیف در
    // ارتفاعِ عکس (نسبتِ پهنا به طول ≈ ۱ به ۸، مثلِ لمینتِ واقعی). tilesPerImage=16 یعنی با «اندازه‌ی
    // الگو»ی پیش‌فرضِ کف (۴۰)، هر تخته حدودِ ۲۰ سانتی‌متر پهنا و ۱۶۰ سانتی‌متر طول دارد
    tilesPerImage: 16,
    baseSizeCm: 320,
  },
  laminateDark: {
    color: laminateDarkColor,
    normal: laminateDarkNormal,
    roughness: laminateDarkRoughness,
    // همان الگوی لمینتِ روشن، با چوبِ قهوه‌ایِ تیره (WoodFloor064)
    tilesPerImage: 16,
    baseSizeCm: 320,
  },
  plasterWhite: {
    color: plasterWhiteColor,
    normal: plasterWhiteNormal,
    roughness: plasterWhiteRoughness,
    // گچِ سفیدِ بافت‌دار/مات (Plaster001) برای دیوار — برخلافِ «بتن/گچ» (خاکستری و صاف‌تر)، این یکی روشن
    // است و برجستگیِ ماله‌کشیِ واقعی دارد؛ یک‌دست است پس tilesPerImage=1
    tilesPerImage: 1,
    baseSizeCm: 150,
  },
  paintedPlaster: {
    color: paintedPlasterColor,
    normal: paintedPlasterNormal,
    roughness: paintedPlasterRoughness,
    // «رنگِ واقعی» (PaintedPlaster017): سطحِ رنگ‌شده‌ی واقعی با بافتِ ملایمِ غلتک/گچِ زیرش. این همان
    // چیزی است که گزینه‌ی «رنگ» در همه‌ی المان‌ها (دیوار/کف/سقف/در/پنجره) از آن استفاده می‌کند — نگاه
    // کنید به PAINT_SET_KEY. عکسِ اصلی خاکستری (۱۹۰ از ۲۵۵) و ۲:۱ بود؛ این‌جا نسخه‌ی تقریباً سفید و خنثی
    // (فقط بافت، بدونِ رنگ) و مربعی‌شده (دو نسخه‌ی عکس روی هم — عکس بی‌درز است) استفاده می‌شود تا رنگی
    // که کاربر انتخاب می‌کند دقیقاً همان رنگی باشد که دیده می‌شود، نه نسخه‌ی خاکستری/کدرش
    tilesPerImage: 1,
    baseSizeCm: 120,
  },
  wallpaper: {
    color: wallpaperColor,
    normal: wallpaperNormal,
    roughness: wallpaperRoughness,
    // کاغذ دیواریِ بافت‌دار (Wallpaper001A، نوعِ woodchip): کاغذِ سفید با برجستگیِ ریز. مثلِ رنگ، این هم
    // خنثی/سفید شده تا رنگش کاملاً از انتخاب‌گرِ رنگ بیاید
    tilesPerImage: 1,
    baseSizeCm: 80,
  },
};

// ستی که «رنگ» (paint) در همه‌ی المان‌ها از آن استفاده می‌کند — رنگِ واقعی به‌جای رنگِ تختِ ریاضی
export const PAINT_SET_KEY = 'paintedPlaster';

// تکرارِ مناسبِ یک ست روی یک سطحِ مستطیلیِ sizeX×sizeY (سانتی‌متر). اگر ست رگه‌ی جهت‌دار دارد، عکس
// طوری ۹۰ درجه می‌چرخد که رگه همیشه در امتدادِ ضلعِ بلندترِ سطح باشد: grainAlongV (رگه‌ی عمودی، مثلِ
// کاج) روی سطحِ افقی می‌چرخد، grainAlongU (رگه‌ی افقی، مثلِ چوبِ تیره) روی سطحِ عمودی. با چرخش،
// تکرارِ دو محور جابه‌جا می‌شود (چون در three.js، چرخش قبل از repeat اعمال می‌شود)
export function getPbrLayout(set, sizeX, sizeY) {
  if (!set) return { repeatX: 1, repeatY: 1, rotate: false };
  const rotate = (Boolean(set.grainAlongV) && sizeX > sizeY) || (Boolean(set.grainAlongU) && sizeY > sizeX);
  return rotate
    ? { repeatX: sizeY / set.baseSizeCm, repeatY: sizeX / set.baseSizeCm, rotate }
    : { repeatX: sizeX / set.baseSizeCm, repeatY: sizeY / set.baseSizeCm, rotate };
}

const loader = new THREE.TextureLoader();

// کشِ سراسریِ عکس‌ها: هر url فقط «یک بار» دانلود/decode می‌شود و نتیجه‌اش (یک THREE.Source) بینِ همه‌ی
// سطح‌ها مشترک است. هر سطح (دیوار/کف/نبشیِ قاب/...) هنوز Texture مخصوصِ خودش را می‌گیرد — چون repeat/
// offset/rotation مالِ خودِ Texture است و اگر مشترک بود، تغییرِ یکی روی بقیه هم اثر می‌گذاشت — ولی همه‌ی
// این Textureها به همان یک Source اشاره می‌کنند. three.js (از r138 به بعد) برای هر Source با تنظیماتِ
// نمونه‌برداریِ یکسان (wrap/anisotropy/colorSpace) فقط «یک» تکسچر روی کارت گرافیک می‌سازد؛ repeat/offset/
// rotation فقط یک ماتریسِ UV (uniform) هستند و آپلودِ دوباره نمی‌خواهند. نتیجه: ۳۰ دیوارِ آجری = ۱ بار
// decode + ۱ آپلود، نه ۳۰ بار. کیفیت دقیقاً همان است (همان عکس، همان رزولوشن).
//
// چرا texture.clone() ساده نه؟ clone() بلافاصله needsUpdate=true می‌زند؛ اگر عکس هنوز در حالِ دانلود
// باشد، three.js هر فریم هشدارِ «Texture marked for update but no image data found» چاپ می‌کند. برای
// همین این‌جا Textureِ تازه فقط Source را به اشتراک می‌گذارد و «بعد از» رسیدنِ عکس علامتِ به‌روزرسانی
// می‌خورد (Textureهایی که زودتر ساخته شده‌اند در pending منتظر می‌مانند).
const sourceCache = new Map(); // url → { source, loaded, pending: Set<Texture> }
const textureEntry = new WeakMap(); // Texture → entry (برای پاک‌کردن از pending هنگامِ dispose)

function getSourceEntry(url) {
  const cached = sourceCache.get(url);
  if (cached) return cached;
  const entry = { source: null, loaded: false, pending: new Set() };
  const base = loader.load(
    url,
    () => {
      // خودِ TextureLoader روی Textureِ پایه needsUpdate زده (= نسخه‌ی Source بالا رفت، پس یک آپلود)؛
      // برای بقیه فقط نسخه‌ی خودِ Texture را بالا می‌بریم — نه needsUpdate، چون needsUpdate نسخه‌ی
      // Sourceِ مشترک را هم بالا می‌برد و باعثِ آپلودِ دوباره‌ی همان عکس به‌ازای هر سطح می‌شد
      entry.loaded = true;
      entry.pending.forEach((t) => {
        t.version++;
      });
      entry.pending.clear();
    },
    undefined,
    () => {
      // دانلود شکست خورد — از کش بیرون می‌رود تا دفعه‌ی بعد دوباره تلاش شود
      sourceCache.delete(url);
      entry.pending.clear();
    }
  );
  entry.source = base.source;
  sourceCache.set(url, entry);
  return entry;
}

// بارگذاریِ یک نقشه‌ی تکی با تکرارِ مشخص. هر بار یک THREE.Texture تازه (با repeat/offset/rotationِ
// مستقل) برمی‌گرداند که عکسش از کشِ بالا می‌آید — نگاه کنید به توضیحِ sourceCache.
function loadMap(url, repeatX, repeatY, { srgb = false, rotate = false } = {}) {
  if (!url) return null;
  const entry = getSourceEntry(url);
  const tex = new THREE.Texture();
  tex.source = entry.source;
  tex.wrapS = THREE.RepeatWrapping;
  tex.wrapT = THREE.RepeatWrapping;
  tex.repeat.set(repeatX, repeatY);
  if (rotate) {
    tex.center.set(0.5, 0.5);
    tex.rotation = Math.PI / 2;
  }
  tex.anisotropy = 4;
  if (srgb) tex.colorSpace = THREE.SRGBColorSpace;
  if (entry.loaded) {
    tex.version++; // نه needsUpdate — نگاه کنید به توضیحِ onLoad در getSourceEntry
  } else {
    entry.pending.add(tex);
    textureEntry.set(tex, entry);
  }
  return tex;
}

// urls: یکی از مقادیرِ PBR_SETS (شاملِ color/normal/roughness/ao/metalness). فقط نقشه‌ی رنگ باید srgb
// باشد؛ بقیه (normal/roughness/ao/metalness) داده‌ی خطی‌اند و نباید رنگ‌گردانیِ srgb رویشان اعمال شود.
// rotate (اختیاری): چرخشِ ۹۰ درجه‌ی همه‌ی نقشه‌ها با هم — نگاه کنید به getPbrLayout
export function loadPbrMaps(set, repeatX, repeatY, { rotate = false } = {}) {
  if (!set) return null;
  return {
    map: loadMap(set.color, repeatX, repeatY, { srgb: true, rotate }),
    normalMap: loadMap(set.normal, repeatX, repeatY, { rotate }),
    roughnessMap: loadMap(set.roughness, repeatX, repeatY, { rotate }),
    aoMap: loadMap(set.ao, repeatX, repeatY, { rotate }),
    // فلز نبود (set.metalness نبود) = این خط null برمی‌گرداند، دقیقاً مثلِ بقیه‌ی نقشه‌های اختیاری
    metalnessMap: loadMap(set.metalness, repeatX, repeatY, { rotate }),
    // ماسکِ رنگ (فقط برای جنس‌های درزدار مثلِ کاشی/آجر) — داده‌ی خطی، نه srgb
    tintMask: loadMap(set.tintMask, repeatX, repeatY, { rotate }),
  };
}

// dispose روی یک Textureِ اشتراکی، فقط «سهمِ» همین سطح را آزاد می‌کند؛ three.js خودش شمارش می‌کند و
// تکسچرِ کارت گرافیک را فقط وقتی آخرین استفاده‌کننده‌اش dispose شد پاک می‌کند. عکسِ decodeشده هم در
// sourceCache می‌ماند تا اتاق/دیوارِ بعدی دوباره دانلودش نکند.
export function disposePbrMaps(maps) {
  if (!maps) return;
  Object.values(maps).forEach((t) => {
    if (!t) return;
    textureEntry.get(t)?.pending.delete(t);
    t.dispose?.();
  });
}

// aoMap در three.js به یک کانالِ UV دومِ (uv2) نیاز دارد، جدا از UV اصلیِ نقشه‌ی رنگ. چون صفحه‌های
// این پروژه (کف/دیوار) فقط یک UV دارند، همان UV را به‌عنوانِ uv2 هم کپی می‌کنیم — کاملاً بی‌خطر برای
// جنس‌هایی که اصلاً aoMap ندارند (فقط یک attribute اضافه و بلااستفاده می‌ماند)
export function ensureUv2(geometry) {
  if (geometry && geometry.attributes && geometry.attributes.uv && !geometry.attributes.uv2) {
    geometry.setAttribute('uv2', geometry.attributes.uv);
  }
}
// ---------------------------------------------------------------------------------------------------
// «رنگ‌آمیزیِ هوشمند»: در three.js رنگِ متریال (material.color) روی «کلِ» عکس ضرب می‌شود — برای کاشی یعنی
// بندکشی هم هم‌رنگِ کاشی می‌شود و برای آجر، ملات هم؛ نتیجه حسِ «رنگِ کامپیوتری» می‌دهد. برای جنس‌هایی که
// ماسکِ رنگ (tintMask) دارند، رنگ فقط از طریقِ ماسک اعمال می‌شود: خودِ کاشی/آجر رنگ می‌گیرد، درز/ملات رنگِ
// طبیعیِ خودش را نگه می‌دارد، و سایه‌روشن/لک/رگه‌ی عکس (چون رنگ ضرب می‌شود، نه جایگزین) حفظ می‌شود —
// درست مثلِ کاشیِ لعاب‌رنگیِ واقعی. سفید همچنان یعنی رنگِ طبیعیِ خودِ عکس.
//
// روش: یک قدمِ کوچک به شیدرِ استانداردِ three.js، درست بعد از <map_fragment>، با همان UVِ نقشه‌ی رنگ
// (vMapUv) — پس repeat/offset/rotationِ ماسک خودبه‌خود با عکس هم‌راستاست.
// برای جنس‌های بدونِ ماسک، دقیقاً همان رفتارِ قبلی (color روی کلِ عکس) برمی‌گردد.
const TINT_CACHE_KEY = () => 'khoonero-tint-mask';

export function useTintProps(set, maps, color) {
  const uniforms = useMemo(
    () => ({ tintColor: { value: new THREE.Color('#ffffff') }, tintMask: { value: null } }),
    []
  );
  // مقادیر هر رندر به‌روز می‌شوند؛ چون شیدر به همین شیءهای uniform وصل است، تغییرِ رنگ بدونِ کامپایلِ
  // دوباره فوراً دیده می‌شود
  uniforms.tintColor.value.set(color || '#ffffff');
  uniforms.tintMask.value = maps?.tintMask || null;

  const onBeforeCompile = useCallback(
    (shader) => {
      shader.uniforms.tintColor = uniforms.tintColor;
      shader.uniforms.tintMask = uniforms.tintMask;
      shader.fragmentShader = shader.fragmentShader
        .replace('#include <common>', '#include <common>\nuniform vec3 tintColor;\nuniform sampler2D tintMask;')
        .replace(
          '#include <map_fragment>',
          '#include <map_fragment>\n#ifdef USE_MAP\n\tdiffuseColor.rgb *= mix( vec3( 1.0 ), tintColor, texture2D( tintMask, vMapUv ).r );\n#endif'
        );
    },
    [uniforms]
  );

  if (!set?.tintMask) return { color };
  // رنگِ خودِ متریال سفید می‌ماند؛ رنگِ انتخابی فقط از طریقِ ماسک (در شیدر) اعمال می‌شود
  return { color: '#ffffff', onBeforeCompile, customProgramCacheKey: TINT_CACHE_KEY };
}